import { Model } from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class Articledetail extends Model {
  static entity = 'articledetails';  
  
  static fields () {
    return {
      id: this.number(null),
      lngtext: this.string(null),
      shrttext: this.string(null),
      lvtext: this.string(null),
      language_id: this.number(null),
      articles_id: this.number(null),

      article: this.belongsTo(Article, 'articles_id')
    }
  }
}
  